/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuietHours
 */
export interface QuietHours {
    /**
     * 
     * @type {string}
     * @memberof QuietHours
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof QuietHours
     */
    end?: string;
    /**
     * 
     * @type {string}
     * @memberof QuietHours
     */
    timezone?: string;
}

/**
 * Check if a given object implements the QuietHours interface.
 */
export function instanceOfQuietHours(value: object): value is QuietHours {
    return true;
}

export function QuietHoursFromJSON(json: any): QuietHours {
    return QuietHoursFromJSONTyped(json, false);
}

export function QuietHoursFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuietHours {
    if (json == null) {
        return json;
    }
    return {
        
        'start': json['start'] == null ? undefined : json['start'],
        'end': json['end'] == null ? undefined : json['end'],
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
    };
}

export function QuietHoursToJSON(json: any): QuietHours {
    return QuietHoursToJSONTyped(json, false);
}

export function QuietHoursToJSONTyped(value?: QuietHours | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'start': value['start'],
        'end': value['end'],
        'timezone': value['timezone'],
    };
}

